import { Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const getHeroSectionBackground = (color) => {
  return `radial-gradient(35.36% 35.36% at 100% 25%,#0000 66%,${color} 68% 70%,#0000 72%) 13px 13px/calc(2*13px) calc(2*13px), radial-gradient(35.36% 35.36% at 0    75%,#0000 66%,${color} 68% 70%,#0000 72%) 13px 13px/calc(2*13px) calc(2*13px), radial-gradient(35.36% 35.36% at 100% 25%,#0000 66%,${color} 68% 70%,#0000 72%) 0 0/calc(2*13px) calc(2*13px), radial-gradient(35.36% 35.36% at 0    75%,#0000 66%,${color} 68% 70%,#0000 72%) 0 0/calc(2*13px) calc(2*13px), repeating-conic-gradient(#ffffff 0 25%,#0000 0 50%) 0 0/calc(2*13px) calc(2*13px), radial-gradient(#0000 66%,${color} 68% 70%,#0000 72%) 0 calc(13px/2)/13px 13px #ffffff`;
};

const useStyles = makeStyles((theme) => {
  return {
    root: {
      width: "100%",
      textAlign: "center",
      // height: "100%",
      // display: "flex",
      // justifyContent: "space-between",
      // flexDirection: "column",
    },
    heroSection: {
      justifyContent: "center !important",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        padding: "0 20px",
        boxSizing: "border-box",
      },
    },
    careersPageSection: {
      minHeight: "500px",
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      flexDirection: "column",
      alignItems: "center",
    },
    viewAllOpeningsButton: {
      padding: "8px 28px",
      marginTop: theme.spacing(1),
      fontSize: "16px",
      fontWeight: "bolder",
    },
    mainHeading: {
      marginTop: theme.spacing(10),
      fontWeight: "bolder",
      fontSize: "48px",
    },
    benefitsSection: {
      backgroundColor: theme.palette.secondary.main + "04",
    },
    aboutSectionMain: {
      backgroundColor: "#F9F9F9",
      padding: "160px",
      paddingTop: "48px",
      paddingBottom: "48px",
      textAlign: "left",
      [theme.breakpoints.down("sm")]: {
        padding: "24px",
      },
    },
    aboutSectionHeading: {
      fontSize: "28px",
      paddingTop: "36px",
      paddingBottom: "14px",
      fontWeight: "700",
      textAlign: "left",
    },
  };
});

export default function TheBetterIndiaCareersPage(props) {
  const classes = useStyles();

  const scrollToOpenPositions = () => {
    const element = document.getElementById("job-openings-list");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={classes.root}>
      <div
        className={`${classes.heroSection} ${classes.careersPageSection} `}
        style={{
          background: getHeroSectionBackground(
            props.companyDetails.customStyle.themeSecondaryColor
          ),
        }}
      >
        <Typography component="h1" variant="h4" className={classes.mainHeading}>
          Join our team
        </Typography>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.viewAllOpeningsButton}
          size={"medium"}
          onClick={scrollToOpenPositions}
        >
          View open jobs
        </Button>
      </div>
      <div className={classes.aboutSectionMain}>
        <div className={classes.aboutSection}>
          <Typography
            component="h3"
            variant="h4"
            className={classes.aboutSectionHeading}
          >
            Every company promises to change the world. Join one that actually
            does it.
          </Typography>
          <div>Positive impact through Content, Community and Commerce</div>
        </div>
        <div className={classes.ourVisionSection}>
          <Typography
            component="h3"
            variant="h4"
            className={classes.aboutSectionHeading}
          >
            How do we do it?
          </Typography>
          <div>
            The first step to changing the world is changing hearts and minds.
            The stories of people who are leading by example are moving millions
            to action. We are doing this with the power of the Internet,
            technology, and community. Our award-winning content is read and
            watched by some of the biggest names in media, entertainment,
            industry, and government, not to mention millions of citizens every
            day.
          </div>
        </div>
      </div>
    </div>
  );
}
